import { Address } from "viem";
import { LotteryStatistics } from "../../../../models/LotteryStatistics";
import Headline from "../../../miscellaneous/Headline";
import NumberStatistics from "./components/NumberStatistics";
import OverallStatistcis from "./components/OverallStatistcis";
import CharityStatistics from "./components/CharityStatistics";
import { Charity } from "../../../../models/Charity";

export interface StatisticsProps {
  statistics: LotteryStatistics;
  latestDrawNumber: bigint;
  currentCharity?: Address;
  charities: Charity[];
  address?: Address;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function Statistics(props: StatisticsProps) {
  return (
    <div className="flex flex-col justify-center items-center">
      <div className="w-[50%] mb-4 pt-[48px]">
        <Headline value={"STATISTICS"}></Headline>
      </div>
      <OverallStatistcis statistics={props.statistics}></OverallStatistcis>
      <CharityStatistics
        charities={props.charities}
        current={props.currentCharity}
        you={props.address}
      ></CharityStatistics>
      <NumberStatistics
        statistics={props.statistics}
        latestDrawNumber={props.latestDrawNumber}
        currentCharity={props.currentCharity}
      ></NumberStatistics>
    </div>
  );
}
